/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ScreenFieldService = {
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async getGlobalFields() {
    const requestScreenData = {
      url: "api/ScreenField",
      select: ["Code", "Definition"],
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { ScreenFieldService };
